import React from 'react';
import {Link as ScrollLink} from 'react-scroll';
import {Link} from 'react-router-dom';
import {FaFacebookF, FaLinkedinIn} from 'react-icons/fa';
import {HiHeart} from 'react-icons/hi';

const quickLinks = [
  { to: 'home', label: 'Home' },
  { to: 'about', label: 'About' },
  { to: 'services', label: 'Services' },
  { to: 'contact', label: 'Contact' },
];

const serviceLinks = [
  { name: 'CV Writing Services', slug: 'cv-writing' },
  { name: 'Student support', slug: 'student-support' },
  { name: 'Software Service Collaboration', slug: 'software-collaboration' },
  { name: 'Content Writing', slug: 'content-writing' },
  { name: 'International Flight Ticket Purchasing', slug: 'flight-tickets' },
  { name: 'Small Business Support', slug: 'small-business-support' },
];

const socialLinks = [
  { icon: FaLinkedinIn, href: 'https://www.linkedin.com/in/marina-naznin-217555391', label: 'LinkedIn' },
  { icon: FaFacebookF, href: 'https://www.facebook.com/ashmari.ashmari.3', label: 'Facebook' },
];

const Footer = () => {
  return (
    <footer className="bg-text-dark text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-display text-2xl font-bold">
              Marina
            </span>
            <p className="text-gray-400 text-sm mt-4 leading-relaxed">
              Career & Professional Services Specialist based in the UK.
              Helping you build your future with confidence.
            </p>
            <div className="flex gap-3 mt-6">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary transition-all duration-300"
                  aria-label={social.label}
                >
                  <social.icon size={14} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-bold text-lg mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <ScrollLink
                    to={link.to}
                    smooth={true}
                    offset={-80}
                    duration={500}
                    className="text-gray-400 text-sm hover:text-accent transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </ScrollLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display font-bold text-lg mb-5">Services</h4>
            <ul className="space-y-3">
              {serviceLinks.map((service, index) => (
                <li key={index}>
                  <Link
                    to={`/services/${service.slug}`}
                    className="text-gray-400 text-sm hover:text-accent transition-colors duration-300 cursor-pointer"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm flex items-center gap-1">
              &copy; {new Date().getFullYear()} Marina Naznin Made with{' '}
              <HiHeart className="text-primary-light" /> in the UK.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
